// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IJRC","clinicsSelect":"styles_clinicsSelect__2Wkvz"};